import React, { useEffect } from 'react';
import Modal from 'rsuite/Modal';
import InvalidationForm from 'Components/Common/Invalidation/InvalidationForm';
import PropTypes from 'prop-types';

export default function InvalidationModal(props) {
  const { isOpen, setOpen, emisor, dteType, codigoGeneracion, correoReceptor, onInvalidation } = props;

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {}, []);

  return (
    <>
      <Modal size="md" open={isOpen} onClose={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>{'Invalidacion de DTE'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InvalidationForm close={handleClose} emisor={emisor} correoReceptor={correoReceptor} dteType={dteType} codigoGeneracion={codigoGeneracion} onInvalidation={onInvalidation}/>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
}

InvalidationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  emisor: PropTypes.object,
  dteType: PropTypes.string.isRequired,
  codigoGeneracion: PropTypes.string.isRequired
};
